export function capitalizeFirst(str) {
	if (!str) {
		return "";
	}

	return `${str
		.toString()
		.charAt(0)
		.toUpperCase()}${str.toString().slice(1)}`;
}
